module.exports = __webpack_public_path__ + "img/sl5.9d9ffa66.png";